// React Query keys for Exams (build doc 05 §3.2; binding per 90 #65).
// Every key starts with 'exams', 'ingestion', 'scriptCredits' or
// 'examPublicReport' and never with a task prefix ('assignments', 'tasks',
// 'submissions', 'notifications', 'documents', …), so invalidating exam data
// can never touch task caches and vice versa. Exams hooks use plain
// useQuery/useMutation with the app defaults, never createGlobalState.

export const examKeys = Object.freeze({
  all: ['exams'],
  list: (range) => ['exams', 'list', range],
  detail: (id) => ['exams', 'detail', id],
  handoff: (id) => ['exams', 'handoff', id],
  status: (id) => ['exams', 'status', id],
  notices: ['exams', 'notices'],
  toolLibrary: (id, kind, qid) => ['exams', 'toolLibrary', id, kind, qid],
  imports: (id, runId) => ['exams', 'imports', id, runId],
  marks: (id, markerId) => ['exams', 'marks', id, markerId],
  results: (id) => ['exams', 'results', id], // no params (K26)
  script: (id, sid) => ['exams', 'script', id, sid],
  blind: (id, rid) => ['exams', 'blind', id, rid],
  remarks: (id) => ['exams', 'remarks', id],
  scriptHistory: (id, sid) => ['exams', 'scriptHistory', id, sid],
  samples: (id) => ['exams', 'samples', id],
  feedbackList: (id) => ['exams', 'feedbackList', id],
  scriptFeedback: (id, sid) => ['exams', 'scriptFeedback', id, sid],
  insights: (id, scope) => ['exams', 'insights', id, scope],
  reportModel: (id) => ['exams', 'reportModel', id],
  links: (id) => ['exams', 'links', id],
  studentEmails: (id) => ['exams', 'studentEmails', id],
});

export const ingestionKeys = Object.freeze({
  workspace: (jobId) => ['ingestion', 'workspace', jobId],
  pageUrl: (jobId, size, pageId) => [
    'ingestion',
    'pageUrl',
    jobId,
    size,
    pageId,
  ],
  scriptText: (jobId, scriptId) => ['ingestion', 'scriptText', jobId, scriptId],
  page: (jobId, pageId) => ['ingestion', 'page', jobId, pageId],
});

export const creditKeys = Object.freeze({
  wallet: ['scriptCredits'],
  history: ['scriptCredits', 'history'],
  catalog: ['scriptCredits', 'catalog'],
  payModel: (examId, mode) => ['scriptCredits', 'payModel', examId, mode],
  order: (orderId) => ['scriptCredits', 'order', orderId],
});

// Public report pages (#/r/:token, #/sr/:token). In-memory only.
export const examPublicKeys = Object.freeze({
  report: (token) => ['examPublicReport', token],
  pageUrls: (token, pageId) => ['examPublicReport', 'pageUrl', token, pageId],
});

// Stale times (05 §3.2).
export const EXAM_STALE_TIMES = Object.freeze({
  detail: 0,
  list: 30_000,
  results: 10_000,
  wallet: 30_000,
  pageUrl: 10 * 60_000,
  scriptText: Infinity,
});
